module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding"
  }, [_c('h2', [_vm._v("Авторизация")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "callout alert"
  }, [_c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "form-control style-input",
    attrs: {
      "type": "text",
      "placeholder": "Введите логин"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control style-input",
    attrs: {
      "type": "password",
      "placeholder": "Введите пароль"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button"
  }, [_vm._v("Войти")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Для авторизации используйте логин и пароль от личного кабинеты Платформы LP."), _c('br'), _c('br'), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4225cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 108
// module chunks = 0